import { IndividualsDuplexerChannel } from '@wix/ai-scheduling-assistant-common-lib/commonTypes';
import { useDuplexerSubscription } from './use-duplexer-subscription';

/**
 * Fires whenever an Orion dashboard changes, on the lightweight
 * `individuals-dashboard-changed` channel (entityId-only — the caller refetches;
 * the payload carries no entity body). Dashboards live in the
 * wix.symphony.v1.DashboardService (not the VFS), so this is the dedicated refetch signal the dashboard
 * surfaces (home / workspace / drill-in page) listen on. HTTPS-only (see
 * useDuplexerSubscription).
 */
export function useDashboardDuplexer(onChange: () => void) {
  useDuplexerSubscription(IndividualsDuplexerChannel.DASHBOARD_CHANGED, () => onChange());
}
